module.exports = __webpack_public_path__ + "img/1小时雨量图.109ea5a9.png";